import React from 'react';
import { Redirect } from 'react-router';
import { MARKETING_AUDIENCES } from 'config/routes';

export default () => <Redirect to={MARKETING_AUDIENCES} />;
